import { useEffect, useMemo, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
// @material-ui/core components
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import LocationHeader from "components/Headers/LocationHeader";
import { PAGINATION } from "utils/const";
import RecommendedOpportunities from "./RecommendedOpportunities";
import FilterSection from "./Sections/OpportunitiesFilterSection";
import ResultSection from "./Sections/OpportunitiesResultSection";
const useStylesGeneric = makeStyles(componentStylesGeneric);

function OpportunitiesList(props) {
  const classes = useStylesGeneric();
  const location = useLocation();
  const [showRecommendedOpportunities, setShowRecommendedOpportunities] =
    useState(true);
  const [preLoadOpportunities, setPreLoadOpportunities] = useState(false);
  const isMounted = useRef(false);

  const defaultFormValues = useMemo(
    () => ({
      opportunityType: null,
      province: null,
      opportunityProfessionalCategory: null,
      contractType: null,
      internshipType: null,
      timeTableType: null,
      companyName: "",
      searchText: "",
      pageIndex: PAGINATION.FIRST_PAGE,
      pageSize: PAGINATION.PAGE_SIZE_AVAILABLE_OPPORTUNITIES,
    }),
    []
  );

  const hasInitialSearchParams = (location.search || "") !== "";
  const [filtersReady, setFiltersReady] = useState(!hasInitialSearchParams);

  const form = useForm({
    mode: "onChange",
    defaultValues: defaultFormValues,
  });

  useEffect(() => {
    if (isMounted.current) {
      if (
        !props.opportunitiesState?.searchRecommendedOpportunities_loading &&
        props.opportunitiesState?.recommended_result?.data?.length === 0
      ) {
        setShowRecommendedOpportunities(false);
        setPreLoadOpportunities(true);
      }
    } else {
      isMounted.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.opportunitiesState?.searchRecommendedOpportunities_loading]);

  return (
    <Grid container classes={{ root: classes.containerRoot }}>
      <LocationHeader
        section="Emprego e Estágio Profissional"
      />
      <FormProvider {...form}>
        <Grid item xs={12} md={12}>
          <FilterSection
            showRecommendedOpportunities={showRecommendedOpportunities}
            setShowRecommendedOpportunities={setShowRecommendedOpportunities}
            preLoadOpportunities={preLoadOpportunities}
            defaultFormValues={defaultFormValues}
            filtersReady={filtersReady}
            setFiltersReady={setFiltersReady}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          {showRecommendedOpportunities ? (
            <RecommendedOpportunities />
          ) : (
            <ResultSection />
          )}
        </Grid>
      </FormProvider>
    </Grid>
  );
}

const mapStateToProps = (state) => ({ ...state });

export default connect(mapStateToProps)(OpportunitiesList);
